import Button from './common/Button';
import ConfirmDialog from './common/ConfirmDialog';
import ServerError from './common/ServerError';
import LoadingProgressBar from './common/LoadingProgressBar';
import { browserHistory } from 'react-router';
import SignatureCanvas from 'react-signature-canvas';
import windowSize from 'react-window-size';
import { caseSignGetPdfPublicAction,
         caseSignSignaturePublicAction, 
         caseSignDeclinePdfPublicAction} from '../actions/caseActions';

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Alert } from 'react-bootstrap';
import _ from 'lodash';
import TextInput from './common/TextInput';
import { userMessageLogAction } from './../actions/userActions';


import { Document, Page, pdfjs } from 'react-pdf';

if (typeof window !== 'undefined') {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    import('react-pdf/dist/Page/AnnotationLayer.css');
}


class SignDocument extends PureComponent {
    constructor(props) {
        super(props);
        this.signClicked = this.signClicked.bind(this);
        this.refreshPdfUrl = this.refreshPdfUrl.bind(this);
        this.renderPdfAndSignState = this.renderPdfAndSignState.bind(this);
        this.onDocumentLoad = this.onDocumentLoad.bind(this);
        this.isTextSignature = this.isTextSignature.bind(this);
        this.signees = {};
        this.state = {
            loading: false,
            signing: false,
            signed: false,
            state: 'init',
            serverError: undefined,
            pdfUrl: undefined,
            pdfDownloadUrl: undefined,
            signees: {},
            pdfPages: 0,
            signeeName: '',
            signeeText: undefined,
            signeeSignature: undefined,
            everyoneSigned: false,
        }

        this.signPad = null;
        this.setSignPadRef = element => {
            this.signPad = element;
            if (this.signPad && this.state.signeeSignature) {
                this.signPad.fromDataURL(this.state.signeeSignature, {width: 520, height: 200});
            }
        };
    }

    onDocumentLoad({ numPages }) {
        this.setState({ pdfPages: numPages });
    }

    isTextSignature() {
        return this.props.signPlaceholder && this.props.signPlaceholder.indexOf('docs.SignatureText') >= 0;
    }

    signClicked(_evt) {
        const signPad = this.signPad;
        const isTextSignature = this.isTextSignature();
        if (!isTextSignature && (!signPad || signPad.isEmpty())) {
            this.setState({serverError: 'Please sign either with your mouse or with your finger on the signature pad.'});
            return;
        }

        if (isTextSignature && !this.state.signeeText.trim()) {
            this.setState({serverError: 'Please fill in signature.'});
            return;
        }

        if (!this.state.signeeName.trim() || this.state.signeeName.length >= 300) {
            this.setState({serverError: 'Please provide your full name (300 characters max).'});
            return;
        }

        this.setState({signing: true});
        const signee = {placeholder: this.props.signPlaceholder};
        let signatureData;
        if (isTextSignature) {
            signatureData = this.state.signeeText;
        } else {
            signatureData = signPad.toDataURL();
        }
        
        signee['signature'] = signatureData;
        signee['signeeName'] = this.state.signeeName;

        this.props.dispatch(caseSignSignaturePublicAction(signee, this.props.publicHash))
            .then(result => {
                if (!result) {
                    this.setState({
                        signing: false,
                        serverError: 'Error while submitting signature.',
                        signeeSignature: signatureData
                    });

                    return;
                }

                this.setState({
                    signing: false,
                    signed: true,
                    state: 'pdf',
                    pdfUrl: undefined,
                    pdfDownloadUrl: undefined,
                    signeeSignature: signatureData
                }, () => this.refreshPdfUrl());

            }).catch(error => {
                console.error(new Error().stack, error);
                this.setState({
                    signing: false,
                    serverError: 'Error while submitting signature: ' + error,
                    signeeSignature: signatureData
                });
            })
    }

    refreshPdfUrl() {
        if (this.state.pdfUrl) {
            this.setState({pdfUrl: undefined, pdfDownloadUrl: undefined});
        }

        this.props.dispatch(caseSignGetPdfPublicAction(this.props.publicHash))
            .then(result => {
                if (!result) {
                    this.setState({
                        serverError: 'Error while retrieving agreement pdf download link.'
                    });

                    return;
                }

                const declined = result.data.declined;
                let signState = 'pdf';
                if (declined) {
                    signState = 'declined';
                }

                this.setState({
                    pdfUrl: result.data.pdfUrl,
                    pdfDownloadUrl: result.data.pdfDownloadUrl,
                    everyoneSigned: result.data.signed,
                    state: signState,
                    companyName: result.data.companyName,
                    requesterName: result.data.requesterName,
                    documentName: result.data.documentName,
                });

                browserHistory.push(this.props.originalPath);

            }).catch(error => {
                this.setState({
                    serverError: 'Error while downloading agreement pdf: ' + error
                });
            });
    }

    componentDidMount() {
        if (!this.state.pdfUrl) {
            this.refreshPdfUrl();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.signPlaceholder && !this.props.signPlaceholder) {
            if (this.state.state !== 'sign' && this.state.state !== 'declined') {
                this.setState({state: 'sign'});
                return;
            }
        }
    }

    renderPdfAndSignState() {
        let pdfHeight = this.props.windowHeight * 0.9;
        let pdfViewer = '';
        let loader = (
            <Row style={{'paddingTop': this.props.windowHeight * 0.35, paddingRight: this.props.windowWidth * 0.05}}>
                <LoadingProgressBar loading={true} />
            </Row>
        );

        if (this.state.pdfUrl) {
            pdfViewer = (
                <div style={{height: pdfHeight, paddingLeft: this.props.windowWidth * 0.05, overflowY: 'auto', overflowX: 'hidden'}}>
                <Document file={this.state.pdfUrl}
                          onLoadSuccess={this.onDocumentLoad}
                          loading={loader}
                          externalLinkTarget="_self"
                          error="Failed to load the agreement. Please try to reload the page."
                          onLoadError={error => {
                              console.log(error);
                              if (_.isObject(error) && error.name) {
                                  error = error.name;
                              }

                              if (error === 'MissingPDFException') {
                                  this.setState({ serverError: 'Document has been deleted.' });
                              } else {
                                  this.setState({ serverError: 'Document error!' });
                                  this.props.dispatch(userMessageLogAction(`ERROR: Signature PDF '${this.state.pdfUrl}' loading failure: ${JSON.stringify(error)}`));
                              }
                              debugger
                          }}
                >
                    {_.range(this.state.pdfPages).map(pageNumber => 
                        <div>
                            <Page pageNumber={pageNumber + 1}
                                  width={this.props.windowWidth * 0.9}
                                  renderAnnotationLayer
                                  onGetAnnotationsSuccess={annotations => {
                                      const placeholders = annotations.filter(a => a.url.lastIndexOf('#placeholder=') >= 0).map(a => a.url.substr(a.url.lastIndexOf('#placeholder=') + '#placeholder='.length));
                                      this.signees[pageNumber] = placeholders;
                                      if (placeholders.length === 0) {
                                          delete this.signees[pageNumber];
                                      }

                                      let state = Object.keys(this.signees).length > 0 && !this.state.signed ? 'intent' : 'pdf';
                                      if (this.state.state === 'declined') {
                                          state = 'declined';
                                      }

                                      this.setState({signees: this.signees, state}, () => this.forceUpdate());
                                  }}
                            />
                            <h6 style={{textAlign: 'center'}}>Page {pageNumber + 1} / {this.state.pdfPages}</h6>
                        </div>
                    )}
                </Document>
                <div class="annotationLayer"></div>
                </div>
            );

        } else {
            pdfViewer = loader;
        }

        const isTextSignature = this.isTextSignature();

        return (
            <div style={{overflow: 'hidden'}}>
            <Row>
                <Col xs={12}>
                {pdfViewer}
                </Col>
            </Row>
            <Row>
                <Col xs={1} md={4}></Col>
                {this.state.state != 'sign' && (
                <Col xs={4} md={2}>
                    <form method='get' action={this.state.pdfDownloadUrl}>
                        <Button disabled={!this.state.pdfDownloadUrl}
                                block
                                type='submit'
                                icon="download-alt"
                                label="Download"/>
                    </form>
                </Col>)}
                {Object.keys(this.state.signees).length > 0 && (
                    <Col xs={4} md={2}>
                        <Alert
                            bsStyle="warning"
                            style={{height: 35, padding: 5, textAlign: 'center'}}
                        >
                            <strong>{Object.keys(this.state.signees).length} signature(s) left</strong>
                        </Alert>
                    </Col>
                    )}
            </Row>
            <ConfirmDialog title={`Sign the document: ${Object.keys(this.state.signees).length} signature(s) left`}
                           open={this.state.state  == 'sign'}
                           confirmButton={
                            <div>
                            {!isTextSignature && <Button disabled={this.state.signing || !this.state.signeeName.trim()} onClick={() => { this.setState({signeeName: '', signeeSignature: undefined}); this.signPad.clear(); }} bsStyle="trash" icon="remove" label="Clear" />}
                            <Button disabled={this.state.signing || !this.state.signeeName.trim()} style={{marginLeft: 40}} onClick={this.signClicked} bsStyle="primary" icon="ok" label="Sign" />
                            </div>}
                           cancel={!this.state.signing ?
                                () => {
                                    if (this.state.signing) {
                                        return;
                                    }

                                    if (isTextSignature) {
                                        this.setState({ state: 'pdf', signeeText: this.state.signeeText });
                                    } else {
                                        this.setState({ state: 'pdf', signeeSignature: this.signPad.toDataURL()});
                                    }
                                    browserHistory.push(this.props.originalPath);
                                } : undefined}
                >
                <Row>
                    <Col xs={12}>
                    <TextInput
                        field={{
                            name: 'Name',
                            value: this.state.signeeName,
                            touched: true,
                            onChange: evt => {
                                const signeeName = evt.target.value;
                                this.setState({signeeName: signeeName});
                            }
                        }}
                        onChange={evt => {
                            const signeeName = evt.target.value;
                            this.setState({signeeName: signeeName});
                        }}
                        label='Full Name'
                        help='Please enter your full name.'
                        disabled={this.state.signing}
                    />
                    </Col>
                </Row>
                {this.state.signing && (
                <Row style={{ marginTop: 15 }}>
                    <Col xs={12}>
                        <LoadingProgressBar loading />
                    </Col>
                </Row>)}
                {!this.state.signing && isTextSignature && (
                <Row>
                    <Col xs={12}>
                    <TextInput
                        field={{
                            name: 'Initials',
                            value: this.state.signeeText,
                            touched: true,
                            onChange: evt => {
                                const signeeText = evt.target.value;
                                this.setState({signeeText: signeeText});
                            }
                        }}
                        onChange={evt => {
                            const signeeText = evt.target.value;
                            this.setState({signeeText: signeeText});
                        }}
                        label='Signature'
                        help='Please enter your initials / full name.'
                        disabled={this.state.signing}
                    />
                    </Col>
                </Row>)}
                {!this.state.signing && !isTextSignature && (
                <div style={{ marginLeft: 15, marginRight: 15 }}>
                <Row style={{ marginTop: 15 }}>
                    <Col xs={12}>
                        <label>Signature</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: 15, paddingLeft: 15, paddingRight: 15 }}>
                    <Col xs={12} style={{ border: '2px dotted #6C757D' }}>
                        <SignatureCanvas
                            ref={this.setSignPadRef}
                            canvasProps={{width: 520, height: 200}}
                        />
                    </Col>
                </Row>
                </div>)}

            </ConfirmDialog>
            <ConfirmDialog title='Consent to do business electronically'
                           open={this.state.state  === 'intent'}
                           confirmButton={
                            <div>
                            <Button onClick={() => { this.setState({state: 'declined'}); this.props.dispatch(caseSignDeclinePdfPublicAction(this.props.publicHash)); }} bsStyle="secondary" icon="remove" label="Decline" />
                            <Button style={{marginLeft: 40}} onClick={() => this.setState({state: 'pdf'})} bsStyle="primary" icon="ok" label="Continue" />
                            </div>}
                           disabled={this.state.signing}
                           size='large'>
                <Row>
                    <Col xs={12}>
                        <p>{this.state.requesterName} from {this.state.companyName} requests that you sign <b>{this.state.documentName}.</b></p>
                        <p>The parties agree that this agreement may be electronically signed. The parties agree that the electronic signatures appearing on the agreement are the same as handwritten signatures for the purposes of validity, enforceability, and admissibility.</p>
                    </Col>
                </Row>
            </ConfirmDialog>
            <ConfirmDialog title='Consent to do business electronically - Declined'
                           open={this.state.state  === 'declined'}
                           disabled
                           size='large'>
                <Row>
                    <Col xs={12}>
                        <Alert bsStyle="warning">Electronical signature has been declined.</Alert>
                    </Col>
                </Row>
            </ConfirmDialog>
            </div>
        );
    }

    render() {
        const component = this.renderPdfAndSignState();

        return (
            <div>
            {component}
            <ServerError error={this.state.serverError} style='popup' close={() => {this.setState({serverError: undefined})}} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const originalPath = state.routing.locationBeforeTransitions.pathname;
    const publicHash = originalPath.substring(originalPath.lastIndexOf('/') + 1);
    const hash = state.routing.locationBeforeTransitions.hash;
    let signPlaceholder = '';
    if (hash.startsWith('#placeholder=')) {
        signPlaceholder = hash.substr('#placeholder='.length);
    }

    return {
        publicHash,
        originalPath,
        signPlaceholder
    }
};

export default connect(mapStateToProps)(windowSize(SignDocument));
